import { useMemo } from 'react';
import { useGetWorkspacesInfo } from './useGetWorkspacesInfo';

export const useWorkspaceIds = (params: { accountId: string }): string[] => {
  const { data } = useGetWorkspacesInfo({
    accountId: params.accountId,
    fetchPolicy: 'cache-only',
  });
  return useMemo(() => {
    if (!data?.account?.workspaces?.nodes) return [];
    return data.account.workspaces.nodes.map(({ id }) => id);
  }, [data]);
};
